<div class="card-header">
  <div class="title-section">
    <h2 class="header-title">{{ isEditing ? 'Editar Estatus Legal' : 'Agregar Estatus Legal' }}</h2>
  </div>
  <div class="search-section">
    <div class="button-section">
      <button class="btn-new" mat-raised-button color="accent" (click)="isEditing ? update() : create()" appPermissionControl="P293B0001">
        <mat-icon>save</mat-icon>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button class="btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P293B0002"><mat-icon>arrow_back</mat-icon>Cancelar</button>
    </div>
  </div>
</div>

<form class="mt-5" [formGroup]="form" appPermissionControl="P293F0001">
  <div class="form-row">
    <div class="form-field" color="accent" appearance="outline">
      <label>Estatus</label>
      <input class="form-control" formControlName="estatus" type="text" [readonly]="isEditing" required appPermissionControl="P293K0001">
    </div>

    <div class="form-field" color="accent" appearance="outline">
      <label>Descripción</label>
      <input class="form-control" formControlName="descripcion" type="text" required appPermissionControl="P293K0002">
    </div>

    <div class="line-break"></div>

    <div class="form-field" color="accent" appearance="outline">
      <label>Días/Dues</label>
      <select class="form-control" formControlName="diasDues" required appPermissionControl="P293K0003">
        <option value="0">-- Seleccione --</option>
        <option *ngFor="let diasDues of diasDuesOptions" [value]="diasDues.sValor">{{ diasDues.sValor }} | {{ diasDues.sOpcion }}</option>
      </select>
    </div>

    <div class="form-field" color="accent" appearance="outline">
      <label>Mínimo</label>
      <input class="form-control" formControlName="minimo" type="number" appPermissionControl="P293K0004">
    </div>

    <div class="form-field" color="accent" appearance="outline">
      <label>Máximo</label>
      <input class="form-control" formControlName="maximo" type="number" appPermissionControl="P293K0005">
    </div>

    <div class="form-field" color="accent" appearance="outline">
      <label>Provisión</label>
      <input class="form-control" formControlName="provision" type="number" appPermissionControl="P293K0006">
    </div>

    <div class="form-field" color="accent" appearance="outline">
      <label>Provisión Int.</label>
      <input class="form-control" formControlName="provisionInt" type="number" appPermissionControl="P293K0007">
    </div>

    <div class="form-field" color="accent" appearance="outline">
      <label>Clase Cartera</label>
      <select class="form-control" formControlName="clasCartera" appPermissionControl="P293K0008">
        <option value="0">-- Seleccione --</option>
        <option *ngFor="let clasCartera of clasCarteraOptions" [value]="clasCartera.sValor">{{ clasCartera.sValor }} | {{ clasCartera.sOpcion }}</option>
      </select>
    </div>

    <div class="form-field" color="accent" appearance="outline">
      <label>Porc. Garantía</label>
      <input class="form-control" formControlName="porcGarantia" type="number" appPermissionControl="P293K0009">
    </div>

    <div class="form-field" color="accent" appearance="outline">
      <label>Origen Reserva</label>
      <select class="form-control" formControlName="origenReserva" appPermissionControl="P293K0010">
        <option value="0">-- Seleccione --</option>
        <option *ngFor="let origenReserva of origenReservaOptions" [value]="origenReserva.sValor">{{ origenReserva.sValor }} | {{ origenReserva.sOpcion }}</option>
      </select>
    </div>
  </div>
</form>
